import React from 'react';
import { Link } from 'react-router-dom';
import { Target, ArrowLeft, MapPin, Mail } from 'lucide-react';
import SEOHead from '@/components/SEOHead';

const ContactPage = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEOHead title="Contact Us — O4S.ai" path="/contact" />

      <nav className="glass-nav sticky top-0 z-50 px-4 md:px-8 py-3 border-b border-earth-200">
        <div className="max-w-4xl mx-auto flex items-center gap-3">
          <Link to="/" className="flex items-center gap-2 text-earth-500 hover:text-earth-700 transition-colors">
            <ArrowLeft className="w-4 h-4" />
            <div className="w-8 h-8 bg-primary rounded-lg flex items-center justify-center">
              <Target className="w-4 h-4 text-white" />
            </div>
            <span className="font-bold text-earth-700">O4S.ai</span>
          </Link>
        </div>
      </nav>

      <main className="max-w-4xl mx-auto px-4 md:px-8 py-10 md:py-16">
        <h1 className="text-3xl sm:text-4xl font-bold text-earth-700 mb-2">Contact Us</h1>
        <p className="text-earth-500 text-lg mb-10">We would love to hear from you</p>

        <div className="grid md:grid-cols-2 gap-6 mb-10">
          <div className="bg-white rounded-2xl border border-earth-200 p-6">
            <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center mb-4">
              <MapPin className="w-5 h-5 text-primary" />
            </div>
            <h2 className="text-lg font-bold text-earth-700 mb-2">Our Address</h2>
            <p className="text-earth-600 leading-relaxed">
              3-3-395, Masjid Line<br />
              LB Nagar, Hyderabad - 500074<br />
              Telangana, India
            </p>
          </div>

          <div className="bg-white rounded-2xl border border-earth-200 p-6">
            <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center mb-4">
              <Mail className="w-5 h-5 text-primary" />
            </div>
            <h2 className="text-lg font-bold text-earth-700 mb-2">Get in Touch</h2>
            <p className="text-earth-600 leading-relaxed mb-3">For enquiries, feedback, or partnership opportunities, please reach out to us.</p>
            <a href="mailto:teamkkm.digital@gmail.com" className="flex items-center gap-2 text-primary font-semibold text-sm hover:underline">
              <Mail className="w-4 h-4" />
              <span>teamkkm.digital@gmail.com</span>
            </a>
          </div>
        </div>

        <section className="mb-10">
          <h2 className="text-xl font-bold text-earth-700 mb-3">When to Contact Us</h2>
          <ul className="space-y-2 text-earth-600">
            <li className="flex gap-2"><span className="text-primary font-bold">-</span> Questions about your career assessment results</li>
            <li className="flex gap-2"><span className="text-primary font-bold">-</span> Feedback or suggestions for improving O4S.ai</li>
            <li className="flex gap-2"><span className="text-primary font-bold">-</span> Partnership or collaboration enquiries</li>
            <li className="flex gap-2"><span className="text-primary font-bold">-</span> Data privacy or account-related requests</li>
            <li className="flex gap-2"><span className="text-primary font-bold">-</span> Reporting technical issues or bugs</li>
          </ul>
        </section>

        <div className="bg-surface-alt rounded-xl border border-earth-200 p-6 text-center">
          <p className="text-earth-600 italic text-sm leading-relaxed">"I used O4S.ai for my career growth, and the AI-guided recommendations were extremely helpful, a must-try tool for taking your career to the next level."</p>
        </div>
      </main>

      <footer className="px-4 md:px-8 py-8 bg-earth-700 text-white mt-auto">
        <div className="max-w-4xl mx-auto">
          <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-sm mb-4">
            <Link to="/about" className="text-earth-400 hover:text-white transition-colors">About</Link>
            <Link to="/founder" className="text-earth-400 hover:text-white transition-colors">Founder</Link>
            <Link to="/contact" className="text-earth-400 hover:text-white transition-colors">Contact</Link>
            <Link to="/privacy" className="text-earth-400 hover:text-white transition-colors">Privacy</Link>
            <Link to="/terms" className="text-earth-400 hover:text-white transition-colors">Terms</Link>
            <Link to="/legal" className="text-earth-400 hover:text-white transition-colors">Legal</Link>
          </div>
          <p className="text-earth-500 text-xs text-center">&copy; 2026 O4S.ai. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default ContactPage;
